export default "__VITE_ASSET__DAAU5CNa__"